import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";

const apiService = new ApiService();

/** Errors are thrown with the backend's message so the page can show it. */
const messageOf = (error) =>
  error?.response?.data?.message || error?.response?.data?.error || error?.message || "Request failed";

export const listFeatureFlags = async () => {
  try {
    const response = await apiService.get(apiEndPoints.featureFlags);
    return response?.data ?? [];
  } catch (error) {
    throw new Error(messageOf(error));
  }
};

export const updateFeatureFlag = async (key, configuration) => {
  try {
    return await apiService.update(`${apiEndPoints.featureFlags}/${encodeURIComponent(key)}`, configuration);
  } catch (error) {
    throw new Error(messageOf(error));
  }
};

export const getFeatureFlagHistory = async (key) => {
  try {
    const response = await apiService.get(`${apiEndPoints.featureFlags}/${encodeURIComponent(key)}/history`);
    return response?.data ?? [];
  } catch (error) {
    throw new Error(messageOf(error));
  }
};

export const searchScopeOptions = async (type, search) => {
  try {
    const query = `type=${encodeURIComponent(type)}&search=${encodeURIComponent(search || "")}`;
    const response = await apiService.get(`${apiEndPoints.featureFlags}/scope-options?${query}`);
    return response?.data ?? [];
  } catch (error) {
    throw new Error(messageOf(error));
  }
};
